import { render, staticRenderFns } from "./MarketingComponent.vue?vue&type=template&id=ee34ba8c&scoped=true&"
import script from "./MarketingComponent.vue?vue&type=script&lang=js&"
export * from "./MarketingComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarketingComponent.vue?vue&type=style&index=0&id=ee34ba8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee34ba8c",
  null
  
)

export default component.exports